module.exports = __webpack_public_path__ + "img/product.aba187da.png";